import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Grid, Form, Segment } from 'semantic-ui-react'

const PublicLinks = ({ publicLinks, setPublicLinks }) => {
  const [linkedinUrl, setLinkedinUrl] = useState(
    publicLinks.find((url) => url.includes('linkedin.com')) || ''
  )
  const [otherUrls, setOtherUrls] = useState(
    publicLinks
      .filter((url) => !url.includes('linkedin.com'))
      .map((url) => ({ id: uuidv4(), url }))
  )

  const syncPublicLinks = (updatedLinkedinUrl, updatedOtherUrls) => {
    setLinkedinUrl(updatedLinkedinUrl)
    setOtherUrls(updatedOtherUrls)
    const cleanOtherUrls = updatedOtherUrls.map((ol) => ol.url)
    setPublicLinks([updatedLinkedinUrl, ...cleanOtherUrls])
  }

  const updateOtherUrlAtIndex = (index, newUrl) => {
    const updatedOtherUrls = [...otherUrls]
    updatedOtherUrls[index] = {
      id: updatedOtherUrls[index].id,
      url: newUrl,
    }
    syncPublicLinks(linkedinUrl, updatedOtherUrls)
  }

  const addUrl = () => {
    syncPublicLinks(linkedinUrl, [...otherUrls, { id: uuidv4(), url: '' }])
  }

  const deleteUrl = (index) => {
    const updatedOtherUrls = [...otherUrls]
    updatedOtherUrls.splice(index, 1)
    syncPublicLinks(linkedinUrl, updatedOtherUrls)
  }

  return (
    <Form.Field>
      <label>Public Links</label>
      <Segment>
        <Grid container>
          <Grid.Row>
            <Grid.Column />
            <Grid.Column width={15}>
              <Form.Input
                label="LinkedIn URL"
                placeholder="https://www.linkedin.com/in/your-profile"
                fluid
                value={linkedinUrl}
                onChange={(e, { value }) => syncPublicLinks(value, otherUrls)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Grid>
                {otherUrls.map((ol, index) => (
                  <Grid.Row key={ol.id}>
                    <Grid.Column width={1} verticalAlign="middle">
                      <Form.Button
                        circular
                        basic
                        icon="trash"
                        onClick={() => deleteUrl(index)}
                      />
                    </Grid.Column>
                    <Grid.Column width={15}>
                      <Form.Input
                        key={ol.key}
                        label="Other URL"
                        placeholder="https://"
                        fluid
                        value={ol.url}
                        onChange={(e, { value }) =>
                          updateOtherUrlAtIndex(index, value)
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>
                ))}
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <Form.Button primary content="Add More" onClick={addUrl} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Form.Field>
  )
}

export default PublicLinks
